<template>
  <RightSheet style="width: 80vw;" v-model="dialogVisible" max-width="1920">
    <div class="dialog-wrapper">
      <!-- 标题 -->
      <div class="dialog-title">
        <v-btn icon variant="text" class="back-btn" @click="closeDialog">
          <v-icon>mdi-reply-outline</v-icon>
          返回
        </v-btn>
        <span v-if="blockData?.name">{{ blockData?.name }}</span>
        <span v-else>{{ blockData?.eBlockName }} - PCS运行参数</span>
        <span class="sample-time">采样时间：{{ currentTime }}</span>
      </div>
      <DataCardPropsProvide title-position="bottom" :value-style="{ fontSize: '16px', fontWeight: 700 }">
        <!-- 主内容区域 -->
        <div class="dialog-main pcs-detail-dialog-main">
          <!-- 六列详细值 - 不需要左侧图片 -->
          <div class="pcs-detail-content">
            <!-- <div class="pcs-section-header">pcs-运行参数</div> -->

            <div class="pcs-grid-container">
              <!-- 上半部分 -->
              <div class="pcs-row">
                <!-- 第一列：状态 -->
                <div class="grid-column">
                  <div class="monitor-group">
                    <div class="detail-card header-card">
                      <div class="header-icon-bg status-bg">
                        <div class="inner-dot"></div>
                      </div>
                      状态
                    </div>
                    <div class="group-grid">
                      <!-- <div class="detail-card">
                      <div class="card-value status-text">
                        {{ statusData.runState }}
                      </div>
                      <div class="card-label">PCS运行状态</div>
                    </div> -->
                      <DataCard class="kv" title="PCS运行状态" :value="statusData.runState" />
                      <DataCard class="kv" title="PCS运行模式" :value="statusData.runMode" />
                      <!-- <div class="detail-card">
                      <div class="card-value">{{ statusData.runMode }}</div>
                      <div class="card-label">PCS运行模式</div>
                    </div> -->
                      <DataCard class="kv" title="变流器效率" :value="statusData.efficiency" />
                      <DataCard class="kv" title="对地绝缘阻抗" :value="statusData.insulation" />
                      <DataCard class="kv" title="直流接触器状态" :value="statusData.dcContactorState" />
                      <DataCard class="kv" title="交流接触器状态" :value="statusData.acContactorState" />
                    </div>
                  </div>
                </div>

                <!-- 第二列：功率 -->
                <div class="grid-column">
                  <div class="monitor-group">
                    <div class="detail-card header-card">
                      <v-icon class="header-icon" color="#39D8BB" size="20">mdi-chart-line-variant</v-icon>
                      功率
                    </div>
                    <div class="group-grid">
                      <DataCard class="kv" title="有功功率" :value="powerData.activePower" />
                      <DataCard class="kv" title="无功功率" :value="powerData.reactivePower" />
                      <DataCard class="kv" title="视在功率" :value="powerData.apparentPower" />
                      <DataCard class="kv" title="功率因数" :value="powerData.powerFactor" />
                    </div>
                  </div>
                </div>

                <!-- 第三列：温度 -->
                <div class="grid-column">
                  <div class="monitor-group">
                    <div class="detail-card header-card">
                      <v-icon class="header-icon" color="#39D8BB" size="20">mdi-thermometer</v-icon>
                      温度
                    </div>
                    <div class="group-grid">
                      <DataCard class="kv" title="环境温度" :value="tempData.ambient" />
                      <DataCard class="kv" title="机箱内温度" :value="tempData.inner" />
                      <DataCard class="kv" title="IGBT-A温度" :value="tempData.igbtA" />
                      <DataCard class="kv" title="IGBT-B温度" :value="tempData.igbtB" />
                      <DataCard class="kv" title="IGBT-C温度" :value="tempData.igbtC" />
                    </div>
                  </div>
                </div>

                <!-- 第四列：电网信息 -->
                <div class="grid-column">
                  <div class="monitor-group">
                    <div class="detail-card header-card">
                      <v-icon class="header-icon" color="#39D8BB" size="20">mdi-transmission-tower</v-icon>
                      电网信息
                    </div>
                    <div class="group-grid">
                      <DataCard class="kv" title="AB线电压" :value="gridData.uAB" />
                      <DataCard class="kv" title="BC线电压" :value="gridData.uBC" />
                      <DataCard class="kv" title="CA线电压" :value="gridData.uCA" />
                      <DataCard class="kv" title="A相电流" :value="gridData.iA" />
                      <DataCard class="kv" title="B相电流" :value="gridData.iB" />
                      <DataCard class="kv" title="C相电流" :value="gridData.iC" />
                      <DataCard class="kv" title="电网频率" :value="gridData.frequency" />
                    </div>
                  </div>
                </div>
              </div>

              <!-- 下半部分 -->
              <div class="pcs-row mt-6">
                <!-- 第一列位置：直流信息 -->
                <div class="grid-column">
                  <div class="monitor-group">
                    <div class="detail-card header-card">
                      <v-icon class="header-icon" color="#39D8BB" size="20">mdi-flash</v-icon>
                      直流信息
                    </div>
                    <div class="group-grid">
                      <DataCard class="kv" title="电池总压" :value="dcData.voltage" />
                      <DataCard class="kv" title="电池电流" :value="dcData.current" />
                      <DataCard class="kv" title="直流功率" :value="dcData.power" />
                    </div>
                  </div>
                </div>

                <!-- 第二列位置：时间 -->
                <div class="grid-column">
                  <div class="monitor-group">
                    <div class="detail-card header-card">
                      <v-icon class="header-icon" color="#39D8BB" size="20">mdi-clock-time-three-outline</v-icon>
                      时间
                    </div>
                    <div class="group-grid">
                      <DataCard class="kv" title="启动时间" :value="timeData.startTime" />
                      <DataCard class="kv" title="停机时间" :value="timeData.stopTime" />
                    </div>
                  </div>
                </div>

                <!-- 占位列，保持对齐 -->
                <div class="grid-column" style="background: transparent;"></div>
                <div class="grid-column" style="background: transparent;"></div>
              </div>
            </div>
          </div>
        </div>
      </DataCardPropsProvide>

      <!-- 关闭按钮 -->
      <v-btn icon size="small" variant="text" class="close-btn" @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>

    </div>
  </RightSheet>
</template>

<script setup>
import { ref, computed, watch, onUnmounted } from 'vue'
import { ws_req } from '@/ws/wss-request'
import { useStationContext } from '../../composables/useStationContext'
import RightSheet from '@/components/RightSheet/index.vue'
import dayjs from 'dayjs'
import DataCard from '@/components/DataCard/index.vue'
import DataCardPropsProvide from '@/components/DataCard/PropProvide.vue'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  blockData: {
    type: Object,
    default: () => ({})
  },
  realData: {
    type: Object,
  }
})

const emit = defineEmits(['update:modelValue'])

const dialogVisible = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
})

// 使用 composable 获取电站上下文信息
const { stationId: currentStationId } = useStationContext()

const currentTime = ref(new Date().toLocaleString())
const pollingTimer = ref(null)
const pcsData = ref(null)

// 监听实时数据变化，更新PCS数据
watch(() => props.realData, (realData) => {
  if (realData) {
    pcsData.value = realData
  }
})

const closeDialog = () => {
  dialogVisible.value = false
}

// PCS运行模式映射
const PCSRunMode = {
  0x0000: '独立逆变',
  0x0001: '直流恒功率',
  0x0002: '交流恒功率',
  0x0003: '直流恒压',
  0x0004: '交流恒流',
  0x0005: 'SVG',
  0x0006: '交流恒压',
  0x0007: '老化模式',
  0x0008: '直流恒流',
}

// PCS运行状态映射
const PCSRunState = {
  0x0000: '停机',
  0x0001: '自检',
  0x0002: '待机',
  0x0003: '并网',
  0x0004: '故障',
}

// PCS运行状态颜色映射
const PCSRunStateColor = {
  0x0000: '#999999', // 停机 - 灰色
  0x0001: '#FFA940', // 自检 - 橙色
  0x0002: '#9E9E9E', // 待机 - 灰色
  0x0003: '#39D8BB', // 并网 - 绿色
  0x0004: '#F44336', // 故障 - 红色
}

// 接触器状态映射
const ContactorStatus = {
  0x00: '断开',
  0x01: '闭合',
  0x02: '未知',
}

// 格式化数值
const formatNumber = (value, decimals = 1) => {
  if (value === null || value === undefined || isNaN(value)) {
    return '--'
  }
  return Number(value).toFixed(decimals)
}

// 格式化数值带单位，支持0
const formatValue = (value, unit = '', decimals = 1) => {
  if (value === null || value === undefined || isNaN(value)) {
    return '--'
  }
  return `${Number(value).toFixed(decimals)}${unit}`
}

// 格式化时间（分钟转为天时分）
const formatTime = (minutes = 0) => {
  const d = Math.floor(minutes / 1440)
  const h = Math.floor((minutes % 1440) / 60)
  const m = Math.floor((minutes % 1440) % 60)
  return (d > 0 ? d + '天' : '') + (h > 0 ? h + '小时' : '') + (m + '分')
}

// 状态数据
const statusData = computed(() => {
  const data = pcsData.value?.data || {}
  const eblockData = data.eblock || {}

  return {
    runState: PCSRunState[eblockData.state_pcs] || '--',
    runStateColor: PCSRunStateColor[eblockData.state_pcs] || '#999999',
    runMode: PCSRunMode[data.pcs_run_mode] || '--',
    efficiency: formatValue(data.efficiency * 100, '%', 2),
    insulation: formatValue(data.r_insulation, 'KΩ', 1),
    dcContactorState: ContactorStatus[data.dc_km_st] || '--',
    acContactorState: ContactorStatus[data.ac_km_st] || '--',
  }
})

// 功率数据
const powerData = computed(() => {
  const data = pcsData.value?.data || {}
  const eblockData = data.eblock || {}

  return {
    activePower: formatValue(eblockData.p_ac, 'kW', 1),
    reactivePower: formatValue(eblockData.q, 'kVar', 1),
    apparentPower: formatValue(eblockData.s, 'kVA', 1),
    avgPower: formatValue(eblockData.p_avg, 'kW', 1),
    powerFactor: formatNumber(eblockData.pf, 2),
  }
})

// 直流信息数据
const dcData = computed(() => {
  const data = pcsData.value?.data || {}
  const eblockData = data.eblock || {}

  return {
    voltage: formatValue(eblockData.u_dc, 'V', 1),
    current: formatValue(eblockData.i_dc, 'A', 1),
    power: formatValue(eblockData.p_dc, 'kW', 1),
  }
})

// 温度数据
const tempData = computed(() => {
  const data = pcsData.value?.data || {}

  return {
    ambient: formatValue(data.temp_ambient, '°C', 1),
    inner: formatValue(data.temp_inner, '°C', 1),
    igbtA: formatValue(data.temp_igbt_a, '°C', 1),
    igbtB: formatValue(data.temp_igbt_b, '°C', 1),
    igbtC: formatValue(data.temp_igbt_c, '°C', 1),
  }
})

// 时间数据
const timeData = computed(() => {
  const data = pcsData.value?.data || {}

  return {
    startTime: data.t_starting ? formatTime(data.t_starting) : '0',
    stopTime: data.t_stoping ? formatTime(data.t_stoping) : '0',
  }
})

// 电网信息数据
const gridData = computed(() => {
  const data = pcsData.value?.data || {}

  return {
    uAB: formatValue(data.u_ab, 'V', 1),
    uBC: formatValue(data.u_bc, 'V', 1),
    uCA: formatValue(data.u_ca, 'V', 1),
    iA: formatValue(data.i_a, 'A', 1),
    iB: formatValue(data.i_b, 'A', 1),
    iC: formatValue(data.i_c, 'A', 1),
    frequency: formatValue(data.f, 'Hz', 2),
  }
})

// 获取 PCS 详情数据
const fetchPcsDetail = async () => {
  try {
    if (!props.blockData?.id || !currentStationId.value) {
      return
    }

    const result = await ws_req.request('ws_eblock_pcs', {
      eBlockId: props.blockData.id,
      stationId: Number(currentStationId.value)
    })

    if (result && Array.isArray(result) && result.length > 0) {
      // 取第一个 PCS 的数据
      const firstPcs = result[0]
      if (firstPcs.data) {
        // 更新采样时间
        currentTime.value = dayjs(firstPcs.sampTime).format('YYYY-MM-DD HH:mm:ss')
        pcsData.value = firstPcs
      }
    }
  } catch (error) {
    console.error('获取 PCS 详情失败:', error)
  }
}

// 开始轮询
const startPolling = () => {
  stopPolling()
  fetchPcsDetail()
  pollingTimer.value = setInterval(fetchPcsDetail, 5000) // 每5秒更新一次
}

// 停止轮询
const stopPolling = () => {
  if (pollingTimer.value) {
    clearInterval(pollingTimer.value)
    pollingTimer.value = null
  }
}

// Watch for dialog opening to fetch data
watch(dialogVisible, (newVal) => {
  if (newVal) {
    currentTime.value = new Date().toLocaleString()
    // 开始获取详情数据

    // 如果实时数据存在，则不开始轮询
    if (!props.realData) {
      startPolling()
    }
  } else {
    stopPolling()
  }
})

// 清理定时器
onUnmounted(() => {
  stopPolling()
})
</script>

<style scoped lang="scss">
.dialog-wrapper {
  position: relative;
  width: 100%;
  height: 100vh;
  padding: 20px 24px 0;
  background-color: #fff !important;
  background: url('@/assets/images/station-monitor/detail-dialog/detail-bg.svg') no-repeat center center;
  background-size: cover;
  border-radius: 30px 30px 0 0 !important;
}

.dialog-title {
  font-family: 'HarmonyOS Sans SC', sans-serif;
  font-size: 20px;
  color: rgba(46, 46, 46, 1);
  font-weight: normal;
  margin-bottom: 20px;
  padding-left: 24px;
  display: flex;
  align-items: center;
}

.close-btn {
  position: absolute;
  top: 16px;
  right: 24px;
  z-index: 10;
}

.dialog-main {
  display: flex;
  gap: 30px;
  height: calc(100% - 83px);
  background: rgba(246, 251, 255, 1);
  border-radius: 30px;
  padding: 20px;
}

/* 详情弹框样式 */
.detail-dialog-main {
  padding: 40px !important;
  gap: 40px !important;
}

.back-btn {
  width: 98px;
  height: 40px;
  border-radius: 12px;
  border: 1px solid #C0CFDA;
  margin-right: 10px;
  margin-left: -10px;
}

.sample-time {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
  position: absolute;
  right: 84px;
  top: 26px;
}

.pcs-detail-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.pcs-section-header {
  font-family: 'HarmonyOS Sans SC', sans-serif;
  font-size: 14px;
  color: rgba(46, 46, 46, 0.6);
  margin-bottom: 20px;
  font-weight: normal;
}

.pcs-grid-container {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  grid-auto-rows: max-content;
  align-items: start;
  gap: 24px;
  flex: 1;
  overflow-y: auto;
}

.pcs-row {
  display: contents;
}

.pcs-row.mt-6 {
  margin-top: 0 !important;
}

.pcs-row .grid-column[style*="background: transparent"] {
  display: none;
}

.grid-column {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  border-radius: 6px;
  overflow: hidden;
}

.monitor-group {
  display: flex;
  flex-direction: column;
  gap: 12px;

}

/* Header Card Styling */
.detail-card.header-card {
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  background-color: transparent;
  border-bottom: 1px solid rgb(236, 236, 236);
  border-radius: 0;
}


.header-icon {
  margin-right: 4px;
}

.header-icon-bg {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 4px;
}

.status-bg {
  /* Placeholder for potential background if icon needs it */
}

.inner-dot {
  width: 8px;
  height: 8px;
  background-color: #4080FF;
  border-radius: 50%;
}

.group-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  padding: 0 12px;
  padding-bottom: 12px;
}

.detail-card {
  background: rgba(239, 244, 251, 0.70);
  border-radius: 10px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  // min-height: 76px;
  justify-content: center;
  box-shadow: none;
  /* Removed shadow to match flat look */
}

.kv {
  background: rgba(239, 244, 251, 0.70);
  border-radius: 10px;
  padding: 16px;
}

.status-text {
  display: flex;
  align-items: center;
  gap: 6px;
}

.status-dot-indicator {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  display: inline-block;
}
</style>
